import { render, staticRenderFns } from "./userxz.vue?vue&type=template&id=d26b324c"
import script from "./userxz.vue?vue&type=script&lang=js"
export * from "./userxz.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports